import { Brand } from '../../types/Brand';
import { BrandId } from '../../types/BrandId';
import { BrandsByCode, BrandsById } from '../utils/Brands';

const upperCaseBrands = ['Mini', 'Gmc', 'Infiniti', 'Bmw'];

function getAll(): Brand[] {
  return BrandsByCode;
}

function getAllByBrandId(): BrandId[] {
  return BrandsById;
}

function getByCode(code: string): string | undefined {
  return getAll().find((x) => x.code.toLowerCase() === code.toLowerCase())?.name;
}

function getByDealerId(dealerId?: string): string | undefined {
  return dealerId ? getByCode(dealerId.slice(0, 2)) : undefined;
}

function getByBrandId(brandId: number): string | undefined {
  return getAllByBrandId().find((x) => x.id === brandId)?.name;
}

function updateMakeName(make: string) {
  if (upperCaseBrands.includes(make)) {
    return make.toUpperCase();
  }
  return make;
}

function getByName(name: string): string | undefined {
  if (name) {
    return getAll().find((x) => x.name.toLowerCase() === name.toLowerCase())?.code;
  } else {
    return '';
  }
}

export const BrandsService = {
  getAll,
  getByCode,
  getByDealerId,
  getByBrandId,
  updateMakeName,
  getByName,
};
